import * as Adapter from "./Adapter";
import { axiosInstance } from "./AxiosConfig";
import FormValidator from "../Utility/FormValidator";
import config from "./Config";

export const postMatch = async (
  firstName,
  lastName,
  birthdate,
  email,
  setWaitingForResponse,
  setSubmitAttemptCount,
  submitAttemptCount,
  setPageLevelError,
  setSuccesfulMatch,
  errorHandler
) => {
  setSubmitAttemptCount(submitAttemptCount + 1);

  let firstNameCheck = FormValidator.validateRequiredField(firstName.value);
  let lastNameCheck = FormValidator.validateRequiredField(lastName.value);
  let birthdateCheck = FormValidator.validateDateOfBirthField(birthdate.value);
  let emailCheck = FormValidator.validateEmailField(email.value);
  let ageRequirementCheck = FormValidator.validateAgeRequirement(birthdate.value);

  if (ageRequirementCheck === 501) {
    setWaitingForResponse(false);
    setPageLevelError(501);
  } else if (firstNameCheck === -1 && lastNameCheck === -1 && birthdateCheck === -1 && emailCheck === -1) {
    setWaitingForResponse(true);

    let requestData = {
      firstName: firstName.value.toUpperCase(),
      lastName: lastName.value.toUpperCase(),
      birthdate: Adapter.adaptDateOfBirth(birthdate.value),
      email: email.value.toUpperCase(),
    };
    setPageLevelError(-1);
    axiosInstance({
      method: "post",
      url: `${config.baseURL}/match`,
      data: {
        data: {
          attributes: {
            firstName: requestData.firstName,
            lastName: requestData.lastName,
            birthdate: requestData.birthdate,
            email: requestData.email,
          },
        },
      },
    })
      .then((response) => {
        setSuccesfulMatch(true);
        window.location.href = response.data.authenticationURL;
      })
      .catch((error) => {
        errorHandler(error);
      });
  } else {
    setWaitingForResponse(false);
    setPageLevelError(0);
  }
};

export const postAuth = async () => {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${config.baseURL}/auth`,
      withCredentials: true,
      data: {}, // Add any required data payload here
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // Return the actual response data
  } catch (error) {
    console.error("Error occurred during postAuth:", error.message);
    return null; // Return null explicitly in case of an error
  }
};
